import styled from 'styled-components';
import { StatusOffer } from '../../utils';

interface ContainerProps {
	$status: StatusOffer;
}

export const Container = styled.div<ContainerProps>`
	${({ theme }) => theme.typography.headlines.h6}
	color: ${({ $status }) =>
		$status === StatusOffer.Soon
			? ({ theme }) => theme.colors.neutral.green
			: ({ theme }) => theme.colors.neutral.red};
`;
